import columns from '../../../../react-table/helpers/columns';
import { sumWithoutGroupTotal, totalRowRatio } from '../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';

export function getNavigationOptions(rowInfo, index) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.OPERATIONAL_ANALYSIS.id,
    mainReportId: ReportDefinitions.CARRIER_ANALYSIS_411.id,
    requestParams: {
      originExchangeOffices: [rowInfo.row.mrdLocation],
      destinationExchangeOffices: [],
      direction: ReportDefinitions.OPERATIONAL_ANALYSIS.reportDirections[0],
      carrierCode: rowInfo.original.carrier[index],
      isSubtotal: index === 0,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export const ownImpcProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.original.ownMrdOperator === true) {
      className = 'bg-blue-spindle';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    MultilineColumn,
    NonZeroNumberColumn,
    MultilineNumberColumn,
    MultilinePercentageColumn,
    MultilineNumberNavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('MRD location', 'mrdLocation').withGetProps(ownImpcProps).withTotalHeader('Total', 'bg-total-grey'),
        new MultilineColumn('Carrier', 'carrier').withGetProps(ownImpcProps).withTotalHeader('', 'bg-total-grey'),
        new MultilineNumberNavigationWithFooterColumn(new NonZeroNumberColumn('Units', 'units').withGetProps(ownImpcProps).withTotalHeader(sumWithoutGroupTotal, 'bg-total-grey'), getNavigationOptions),
        new MultilineNumberColumn('Denested receptacles', 'denestedReceptacles').withGetProps(ownImpcProps).withTotalHeader(sumWithoutGroupTotal, 'bg-total-grey'),
        new MultilineNumberColumn('Attributed', 'attributed').withGetProps(ownImpcProps).withTotalHeader(sumWithoutGroupTotal, 'bg-total-grey'),
        new MultilinePercentageColumn('% Attributed', 'pctAttributed').withGetProps(ownImpcProps).withTotalHeader(totalRowRatio(['attributed', 'denestedReceptacles']), 'bg-total-grey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.OPERATIONAL_ANALYSIS.id,
        mainReportId: ReportDefinitions.CARRIER_ANALYSIS_411.id,
        requestParams: {
          isTotal: true,
          isSubtotal: true,
          carrierCode: '*',
          mrdHandlerId: 0,
          originExchangeOffices: [
            '*',
          ],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
